<script lang="ts">
	import md from '$lib/utils/md';
	import { getCopy } from '$lib/lang/copy.svelte';
	import Section from '$lib/components/fragments/Section.svelte';
	import Carousel from '$lib/components/charts/Carousel.svelte';
	import Picture from '$lib/components/media/Picture.svelte';

	const copy = $derived(getCopy().playbook);
</script>

<Section id="playbook" class="bg-cream text-black">
	<div class="relative mx-auto flex flex-row items-center justify-center gap-10">
		<div class="content-well-sm">
			<h2 class="heading-3 text-blue mb-10 text-center md:text-left">{copy.title}</h2>
			<div class="body-1">{@html md(copy.copy)}</div>
		</div>
		<div class="hidden max-w-[400px] items-center justify-center md:flex">
			<Picture src="playbook.webp" alt={copy.alt} class="h-full w-full object-contain" />
		</div>
	</div>

	<Carousel />
</Section>
